function toggleReviews() {
  let button = $('.reviews__button');
  button.on('click', function() {
    $(this).prev().children('.reviews__description').addClass('active');
    $(this).hide();
  });
}
toggleReviews();